module.exports = __webpack_public_path__ + "img/Fondo-Canada-Blanco-SF.915edf3f.png";